<template>
	<div class="match" v-if="match">
		<div class="wrapper">
			<div class="match_row">
				<div class="match_right">
					<div class="tab">
						<div class="live-command" v-if="match.sport !== 'biathlon'">
							<div class="live-command_date">
								{{ getTime(match.startdate) }}
							</div>
							
							<div class="live-command_row">
								<router-link :to="{ name: 'team', params: { id: match.home_id } }" class="live-command_image">
									<img :src="$hostname + match.home_image_ref" alt="">
									<span :class="boldIfWinner(score.home, score.away, match.status, match, 'home')">{{ match.home_name }}</span>
								</router-link>
								<div class="live-command_content" :class="{__min: match.sport === 'basketball'}">
									<div class="live-command_score" :class="{__min: match.sport === 'basketball'}">
										{{ score.home }} -&nbsp; {{ score.away }}
									</div>
									<div class="live-command_res">
										<div v-if="match.status === 'finished'">ЗАВЕРШЕН</div>
										<div v-if="match.status === 'notstarted'">МАТЧ НЕ НАЧАЛСЯ</div>
									</div>
								</div>
								<router-link :to="{ name: 'team', params: { id: match.away_id } }" class="live-command_image">
									<img :src="$hostname + match.away_image_ref" alt="">
									<span :class="boldIfWinner(score.away, score.home, match.status, match, 'away')">
										{{ match.away_name }}
									</span>
								</router-link>
							</div>
						</div>
						
						<div class="tab_header">
							<a href="#block-1" class="active">Обзор</a>
							<a v-if="showBlock('statistic')" href="#block-2">Статистика</a>
							<a v-if="showBlock('compositions')" href="#block-3">Составы</a>
							<a v-if="showBlock('matches')" href="#block-4">Последние матчи</a>
						</div>
						
						<div class="tab_content">
							<div class="tab_block active" id="block-1">
								<timeline :sport="sport" :match="match" :data="incidents"></timeline>
							</div>
							
							<div class="tab_block" id="block-2">
								<statistic :data="statistics"></statistic>
							</div>
							
							<div class="tab_block" id="block-3">
								<lineups :data="lineups"></lineups>
							</div>
							
							<div class="tab_block" id="block-4">
								<total-results :match="match" :sport="sport" v-if="totalResults" :data="totalResults"></total-results>
								
								<last-result :home="homeMatches" :away="awayMatches" :match="match"></last-result>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	
	import Timeline from '../components/Timeline/Timeline'
	import Statistic from '../components/Statistic/Statistic'
	import Lineups from '../components/Lineups/Lineups'
	import LastResult from "../components/Match/LastResult";
	import TotalResults from "../components/Match/TotalResults";
	
	export default {
		components: {
			Timeline,
			Statistic,
			Lineups,
			LastResult,
			TotalResults
		},
		
		data() {
			return {
				match: null,
				incidents: [],
				lineups: null,
				statistics: [],
				homeMatches: [],
				awayMatches: [],
				togetherMatches: [],
				sport: '',
				totalResults: null
			}
		},
		
		created() {
			this.axios.get('/api/events/' + this.$route.params.id)
				.then(({data}) => {
					this.match = data;
					
					this.incidents = data.incidents;
					this.statistics = data.statistics;
					this.lineups = data.lineups;
					this.sport = this.match.sport;
					
					this.axios.get('/api/events?team_id='+ this.match.home_id +'&status=finished&limit=5&order=startdate')
						.then(({data}) => {
							this.homeMatches = data;
						});
					
					this.axios.get('/api/events?team_id='+ this.match.away_id +'&status=finished&limit=5&order=startdate')
						.then(({data}) => {
							this.awayMatches = data;
						});
					
					this.axios.get('/api/events/h2h?team_id=' + this.match.home_id + '&team_id=' + this.match.away_id)
						.then(({data}) => {
							this.totalResults = data;
						});
				});
		},
		
		computed: {
			score() {
				if (this.match.sport === 'soccer') {
					let home = Number(this.match.results.ordinarytime.home);
					let away = Number(this.match.results.ordinarytime.away);
					
					if (home === away) {
						if (this.match.home_score > this.match.away_score) {
							home += 1;
						} else if (this.match.away_score > this.match.home_score) {
							away += 1;
						}
					}
					
					return {
						home, away
					}
				}
				
				return {
					home: this.match.home_score,
					away: this.match.away_score
				}
			}
		},
				
		methods: {
			getTime(time) {
				return moment(time).locale('ru').format('D MMMM Y, HH:mm')
			},
			boldIfWinner(team1, team2, status, event, type) {
				if (event.sport === 'mma') {
					if (event.results.finalresult && event.results.finalresult[type] === 'won') {
						return ['__bold'];
					}
					
					return[];
				}
				if (Number(team1) > Number(team2) && status === 'finished') {
					return ['__bold'];
				}
				return [];
			},
			showBlock(type) {
				if (type === 'statistic' && (!this.statistics || !this.statistics.length)) {
					return false;
				}
				if (type === 'compositions' && this.lineups) {
					if (this.lineups.coach && Object.keys(this.lineups.coach).length === 0 || this.lineups.reserv && Object.keys(this.lineups.reserv).length === 0 || this.lineups.start && Object.keys(this.lineups.start).length === 0) {
						return false;
					}
				}
				
				if ((type === 'statistic' || type === 'compositions') && this.sport === 'tennis') {
					return false
				}
				
				
				return this.sport !== 'box' &&
					this.sport !== 'mma' &&
					this.sport !== 'biathlon' &&
					this.sport !== 'volleyball'
			}
		}
	}
</script>

<style scoped>

</style>